import type React from "react"
import type { MouseEvent } from "react"

export const isLeftClickEvent = (e: React.MouseEvent) => e.button === 0

export const leftClickEvent =
	<Event extends MouseEvent<HTMLButtonElement>, FN extends (e: Event) => void>(fn: FN) =>
	(e: Event) => {
		if (isLeftClickEvent(e)) fn(e)
	}
